
import { supabase } from '@/integrations/supabase/client';
import { useAuthStore } from '@/store/authStore';

export interface Invitation {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  created_at: string;
  expires_at: string;
  accepted: boolean;
  address?: string;
  street?: string;
  street_number?: string;
  city?: string;
  postcode?: string;
  store_id: string;
  invited_by_user_id?: string;
  token?: string;
}

export async function fetchInvitations(storeId?: string): Promise<Invitation[]> {
  try {
    console.log('Fetching invitations with storeId:', storeId);
    
    // Start with the base query
    let query = supabase.from('employee_invitations').select('*');
    
    // If a store ID is provided, filter by that store
    if (storeId) {
      query = query.eq('store_id', storeId);
    }
    
    // Execute the query
    const { data, error } = await query;
    
    if (error) {
      console.error('Error fetching invitations:', error);
      return [];
    }
    
    console.log('Invitations fetched from database:', data);
    return data || [];
  } catch (error) {
    console.error('Exception fetching invitations:', error);
    return [];
  }
}
